export default __webpack_public_path__ + "static/media/ExportExcel.618d3e17.png";